import React from 'react'
import Smartview from 'widgets/smartviews/Smartview'
import {
  Collection, ExecuteOperationOnPipe,
  ForEachModel,
  WhenCollectionIsEmpty,
  WhenCollectionIsNotEmpty,
  WhenLoaded, WhenModelValue
} from '@morningtrain/react-resources'
import { SelectedDepartmentFilter, StaticFilter } from 'support/filters'
import { Translation, Translator } from '@morningtrain/react-translations'
import SmartviewContentSection from 'widgets/smartviews/partials/SmartviewContentSection'
import moment from 'moment'
import * as UI from 'ui'
import ArrowLinkToOrder from './partials/ArrowLinkToOrder'
import OrderStatusText from './partials/OrderStatusText'
import WhenOrderIsDraft from '../../../pages/app/inventory/order/partials/WhenOrderIsDraft'
import DeleteModelOnClick from '../../../support/actions/generic/DeleteModelOnClick'
import { DeleteButton } from '../../../ui'
import Button from '@storybook/react/dist/demo/Button'

export default function DraftOrdersSmartview () {
  return (
    <Translator namespace='smartviews.draft_orders'>
      <Smartview header={<Translation name='title' />}>
        <Collection resourceName='inventory.order' operationContext={{group: 'draft_orders'}}>
          <SelectedDepartmentFilter />
          <StaticFilter name='status' value={['draft', 'pending']} />
          <StaticFilter
            name='ordered_at'
            value={{
              from: moment().subtract(7, 'days').format('YYYY-MM-DD'),
              to: moment().format('YYYY-MM-DD')
            }}
          />
          <WhenLoaded>
            <WhenCollectionIsEmpty>
              <Translation name='no_draft_orders' />
            </WhenCollectionIsEmpty>
            <WhenCollectionIsNotEmpty>
              <UI.VerticalList>
                <ForEachModel>
                  <SmartviewContentSection>
                    <UI.SpaceBetween>
                      <OrderStatusText />
                      <WhenModelValue name='status' condition={s => s === 'draft'}>
                        <DeleteModelOnClick pipes={<ExecuteOperationOnPipe resourceName='inventory.order' operationContext={{group: 'draft_orders'}} operationName='index' />}>
                          <DeleteButton />
                        </DeleteModelOnClick>
                      </WhenModelValue>
                      <ArrowLinkToOrder />
                    </UI.SpaceBetween>
                  </SmartviewContentSection>
                </ForEachModel>
              </UI.VerticalList>
            </WhenCollectionIsNotEmpty>
          </WhenLoaded>
        </Collection>
      </Smartview>
    </Translator>
  )
}
